import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: { name: 'register' }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../pages/register/index.vue')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('../pages/test/test.vue')
  },
  {
    path: '/doctorRegister',
    name: 'doctorRegister',
    component: () => import('../pages/doctorRegister/index.vue')
  },
  {
    path: '/consumersRegister',
    name: 'consumersRegister',
    component: () => import('../pages/consumersRegister/index.vue')
  },
  {
    path: '/homePage',
    name: 'LShomePage',
    component: () => import('../pages/LShomePage/index.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
